import React from 'react';
import classnames from 'classnames';
import { Heading, HeadingProps } from '../heading';
import { Text } from '../text';

import styles from './facts.module.scss';

export type FactsProps = {
  highlight: Omit<HeadingProps, 'variant'>;
  subline: string;
} & Pick<React.HTMLAttributes<HTMLDivElement>, 'className'>;

const baseClass = 'facts';

export const Facts: React.FC<FactsProps> = ({ highlight, subline, className }) => {
  const classes = classnames(styles[baseClass], className);

  return (
    <div className={classes} data-testid="facts-component">
      <Heading {...highlight} variant="display-functional-200" className={styles[`${baseClass}__highlight`]}>
        {highlight.children}
      </Heading>
      <Text variant="caption-200" className={styles[`${baseClass}__subline`]}>
        {subline}
      </Text>
    </div>
  );
};
